import { useEffect } from 'react';
import { Route } from 'react-router';
import { useMultiLayerDrawerEnabled } from '../../hooks/useMultiLayerDrawerEnabled';

export const CustomizedRoute = props => {
    const { path, render, hasNestedRoutes, pages, registerPage, drawerMode } = props;

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    useEffect(() => {
        if (pages[path] || !isMultiLayerDrawerEnabled || hasNestedRoutes) {
            return;
        }

        registerPage({ path, component: render, drawerMode });
    }, [registerPage, pages, isMultiLayerDrawerEnabled, render, hasNestedRoutes, drawerMode, path]);

    if (!isMultiLayerDrawerEnabled || hasNestedRoutes) {
        return (
            <Route
                path={path}
                render={({ staticContext: _staticContext, exact: _exact, ...renderProps }) =>
                    render({ ...renderProps, path, drawerMode })
                }
            />
        );
    }

    return null;
};
